import React from 'react';
import StepIdentity from './StepIdentity';
import StepLicenses from './StepLicenses';
import StepPractice from './StepPractice';
import StepMalpractice from './StepMalpractice';
import StepExperience from './StepExperience';
import StepReferences from './StepReferences';
import StepFinal from './StepFinal';

export const CRED_STEP_KEYS = [
    'identity',
    'licenses',
    'practice',
    'malpractice',
    'experience',
    'references',
    'final',
] as const;

export type CredStepKey = (typeof CRED_STEP_KEYS)[number];

// 向导、Review 页、Edit info 弹窗共用同一套 Step 组件
export function renderCredStep(key: CredStepKey) {
    switch (key) {
        case 'identity':
            return <StepIdentity />;
        case 'licenses':
            return <StepLicenses />;
        case 'practice':
            return <StepPractice />;
        case 'malpractice':
            return <StepMalpractice />;
        case 'experience':
            return <StepExperience />;
        case 'references':
            return <StepReferences />;
        case 'final':
            return <StepFinal />;
        default:
            return null;
    }
}
